import * as bootstrap from 'bootstrap';
/*
fetch('./data.json')
  .then((response) => {
    return response.json();
  })
  .then((jsondata) => console.log(jsondata));
*/
//fetching JSON file
const myData = require('../data.json');
//let myArray = JSON.parse(myData);
//console.log(myArray);
console.log(myData[0].timeframes.daily.current);

//declaration of variables
let myDailyLink = document.getElementById('daily'),
  myWeeklyLink = document.getElementById('weekly'),
  myMonthlyLink = document.getElementById('monthly'),
  when = document.querySelectorAll('.when'),
  duration = document.querySelectorAll('.duration'),
  time = document.querySelectorAll('.time');

console.log(time);
console.log(duration);

//functions for changing data
//daily data
function changeMyDailyData() {
  for (let i = 0; i < time.length; i++) {
    for (let i = 0; i < myData.length; i++) {
      time[i].innerHTML = myData[i].timeframes.daily.current + 'hrs';
    }
  }
  for (let i = 0; i < duration.length; i++) {
    for (let i = 0; i < myData.length; i++) {
      duration[i].innerHTML = myData[i].timeframes.daily.previous + 'hrs';
    }
  }
}
//weekly data
function changeMyWeeklyData() {
  for (let i = 0; i < time.length; i++) {
    for (let i = 0; i < myData.length; i++) {
      time[i].innerHTML = myData[i].timeframes.weekly.current + 'hrs';
    }
  }
  for (let i = 0; i < duration.length; i++) {
    for (let i = 0; i < myData.length; i++) {
      duration[i].innerHTML = myData[i].timeframes.weekly.previous + 'hrs';
    }
  }
}
//Montly data
function changeMymonthlyData() {
  for (let i = 0; i < time.length; i++) {
    for (let i = 0; i < myData.length; i++) {
      time[i].innerHTML = myData[i].timeframes.monthly.current + 'hrs';
    }
  }
  for (let i = 0; i < duration.length; i++) {
    for (let i = 0; i < myData.length; i++) {
      duration[i].innerHTML = myData[i].timeframes.monthly.previous + 'hrs';
    }
  }
}

//default data view when page loads
window.onload = () => {
  changeMyDailyData();
  for (let i = 0; i < when.length; i++) {
    when[i].textContent = 'Yesterday -';
  }
};

//Eventlisteners
//adding eventlistener to the daily button
myDailyLink.addEventListener('click', () => {
  changeMyDailyData();
  for (let i = 0; i < when.length; i++) {
    when[i].textContent = 'Yesterday -';
  }
});
//adding eventlistener to the weekly button
myWeeklyLink.addEventListener('click', () => {
  changeMyWeeklyData();
  for (let i = 0; i < when.length; i++) {
    when[i].textContent = 'Last Week -';
  }
});
//adding eventlistener to the montly button
myMonthlyLink.addEventListener('click', () => {
  changeMymonthlyData();
  for (let i = 0; i < when.length; i++) {
    when[i].textContent = 'Last Month -';
  }
  for (let i = 0; i < duration.length; i++) {
    duration[i].style.marginLeft = '3px';
  }
});
